import React, { useState } from 'react';
import { Modal } from '@stormwater-software/lib-ui';
import Select from 'react-select';
import SelectFontSignature from '../../UserProfile/SelectFontSignature';
import UploadUserSignature from '../../UserProfile/UploadUserSignature';

interface Props {
  show: boolean;
  onClose: () => void;
  onSaved: () => void;
}

type SignatureType = 'font' | 'upload';

const TYPE_OPTIONS: { value: SignatureType; label: string }[] = [
  { value: 'font', label: 'Font Wise' },
  { value: 'upload', label: 'Upload an image' },
];

const selectStyles = {
  control: (provided: any) => ({
    ...provided,
    borderColor: '#cecac2',
    boxShadow: 'none',
    ':hover': { borderColor: '#48af98', boxShadow: '0 0 0 1px #48af98' },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f9f5ed' : 'white',
    color: '#002230',
    cursor: 'pointer',
    '&:hover': { backgroundColor: '#48af98', color: 'white' },
  }),
};

const AddSignatureModal: React.FC<Props> = ({ show, onClose, onSaved }) => {
  const [type, setType] = useState<{ value: SignatureType; label: string }>(
    TYPE_OPTIONS[0],
  );

  return (
    <Modal
      show={show}
      title='Add Your Signature'
      handleClose={onClose}
      handleSubmit={onClose}
      submitBtnText='Close'
      cancelBtn={false}
    >
      <div style={{ padding: '4px 4px 8px', minWidth: 320 }}>
        <p style={{ fontSize: 13, color: '#666', margin: '0 0 12px' }}>
          Choose how you’d like to create your signature. Once saved it’s
          applied to all your agreements automatically.
        </p>

        <div style={{ marginBottom: 16, maxWidth: 280 }}>
          <label
            style={{
              display: 'block',
              fontSize: 12,
              fontWeight: 600,
              color: '#444',
              marginBottom: 4,
            }}
          >
            Signature Type
          </label>
          <Select
            classNamePrefix='responsive-select'
            isSearchable={false}
            value={type}
            options={TYPE_OPTIONS}
            onChange={(selected) =>
              setType(selected as { value: SignatureType; label: string })
            }
            styles={selectStyles}
            menuPlacement='auto'
          />
        </div>

        <div className='add-signature-body'>
          {type.value === 'font' ? (
            <SelectFontSignature onSaved={onSaved} />
          ) : (
            <UploadUserSignature onSaved={onSaved} />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddSignatureModal;
